export const gridWrapperStyles = {
    position: 'relative',
    // padding: '48px 32px',
    minHeight: 'calc(100vh - 166px)',
    // marginLeft: '320px',
    backgroundColor: '#ffffff',
    // eaeff1
};